import React, { FC } from 'react'
import clsx from 'clsx'
import { useRouter } from 'next/router'

import { cutHashFromURL } from 'utils/getURLData'

import { popupName } from 'constants/auth/auth-data'

import style from './banner-auth-access.module.scss'

interface IBannerAuthAccess {
  txt?: string
  wrapMod?: string
}

const BannerAuthAccess: FC<IBannerAuthAccess> = ({
  txt = 'Для доступа к материалу',
  wrapMod,
}: IBannerAuthAccess) => {
  const router = useRouter()
  const path = cutHashFromURL(router.asPath)

  const handleClick = () => {
    router.push(`${path}#${popupName.registration}`)
  }

  return (
    <div className={clsx(style.wrapper, { [wrapMod as string]: wrapMod })}>
      <div className={style.title}>Доступ ограничен 😔</div>
      <div className={style.txt}>
        {txt}, пожалуйста,<span onClick={handleClick}> войдите</span> на&nbsp;Medpoint
      </div>
    </div>
  )
}

export default BannerAuthAccess
